<template>
  <div>
    <Loader v-if="isTableDataLoading"/>
    <div v-else>
        <Table
          :title="$t('views.directorEdges.title')"
          :addLabel="$t('views.directorEdges.add')"
          :headers="directorHeaders"
          :rows="directorRows"
          :values="directorEdges"
          currentSortKey="name"
          @add="addEdge"
          @edit="addPublicIp"
          @more="moreInfo"
          @export="exportEdges"
        />
    </div>
    <Modal
      name="seeEdge"
      :title="directorEdge.name"
      class="is-large">
      <div class="container">
        <Loader v-if="isDataLoading" />
        <div v-else>
          <table class="table">
            <tbody class="tbody">
              <tr class="tr">
                <td class="td">{{ $t('views.directorEdges.config.name') }} :</td>
                <td class="td">{{directorEdge.name}}</td>
              </tr>
              <tr class="tr">
                <td class="td">{{ $t('views.directorEdges.config.org_vdc_name') }} :</td>
                <td class="td">{{directorEdge.org_vdc_name}}</td>
              </tr>
              <tr class="tr">
                <td class="td">{{ $t('views.directorEdges.config.available_net_count') }} :</td>
                <td class="td">{{directorEdge.available_net_count}}</td>
              </tr>
              <tr class="tr">
                <td class="td">{{ $t('views.directorEdges.config.number_of_ext_networks') }} :</td>
                <td class="td">{{directorEdge.number_of_ext_networks}}</td>
              </tr>
              <tr class="tr">
                <td class="td">{{ $t('views.directorEdges.config.number_of_org_networks') }} :</td>
                <td class="td">{{directorEdge.number_of_org_networks}}</td>
              </tr>
              <tr class="tr">
                <td class="td">{{ $t('views.directorEdges.config.ha_status') }} :</td>
                <td class="td">{{directorEdge.ha_status}}</td>
              </tr>
              <tr class="tr">
                <td class="td">{{ $t('views.directorEdges.config.gateway_backing_config') }} :</td>
                <td class="td">{{directorEdge.gateway_backing_config}}</td>
              </tr>
            </tbody>
          </table>
          <div v-if="directorEdge.uplinks && directorEdge.uplinks.length">
            <p class="mt-20 mb-10">{{ $t('views.directorEdges.config.uplink') }} :</p>
            <table class="table">
              <tbody class="tbody">
                <tr class="tr">
                  <td class="td">Name</td>
                  <td class="td">IP address</td>
                  <td class="td">Use for default route</td>
                  <td class="td">Total ip count</td>
                </tr>

                <template v-for="(link, index) in directorEdge.uplinks">
                  <tr :key="index" class="tr">
                    <td class="td">{{link.interface_name}}</td>
                    <td class="td">{{link.ip_address}}</td>
                    <td class="td">{{link.use_for_default_route}}</td>
                    <td class="td">{{link.total_ip_count}}</td>
                  </tr>
                  <tr v-for="range, index2 in link.ip_ranges" :key="1 + index + index2" class="tr">
                    <td class="td"></td>
                    <td class="td">IP Range {{index2+1}}:</td>

                    <td class="td">{{range.start_address}}</td>
                    <td class="td">{{range.end_address}}</td>
                  </tr>
                </template>
                </tbody>
            </table>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import DIRECTOR from '@/api/director'

import Loader from '@/components/Loader.vue'
import Modal from '@/components/Modal.vue'

import { eventHubMixin } from '@/mixins/event'

export default {
  name: 'DirectorEdges',
  mixins: [eventHubMixin],

  components: {
    Table: () => import('@/components/Table'),
    Loader,
    Modal
  },

  data() {
    return {
      directorEdge: {},
      isDataLoading: false,
      isTableDataLoading: true,
      directorHeaders: [
        {
          label: this.$t('views.directorEdges.config.name'),
          field: 'name',
        },
        {
          label: this.$t('views.directorEdges.config.org_vdc_name'),
          field: 'org_vdc_name',
        },
        {
          label: this.$t('views.directorEdges.config.available_net_count'),
          field: 'available_net_count',
        },
        {
          label: this.$t('views.directorEdges.config.number_of_ext_networks'),
          field: 'number_of_ext_networks',
        },
        {
          label: this.$t('views.directorEdges.config.number_of_org_networks'),
          field: 'number_of_org_networks',
        },
        {
          label: this.$t('views.directorEdges.config.ha_status'),
          field: 'ha_status',
        }
      ],
      directorRows: [
        {
          value: row => row.name,
        },
        {
          value: row => row.org_vdc_name,
        },
        {
          value: row => row.available_net_count,
        },
        {
          value: row => row.number_of_ext_networks,
        },
        {
          value: row => row.number_of_org_networks,
        },
        {
          value: row => row.ha_status,
        },
      ],
      directorEdges: []
    }
  },

  created() {
    this.getEdges()
  },

  computed: {
  },

  methods: {
    getEdges () {
      DIRECTOR.edges().then(
        (res) => {
          if (res.data && res.data.length) {
            this.directorEdges = res.data
          }
          this.isTableDataLoading = false
        },
      )
    },
    moreInfo(data) {
      this.isDataLoading = true
      this.directorEdge = {}
      DIRECTOR.edge({url: data.url, director_host: data.director_host}).then(
        (res) => {
          this.directorEdge = { ...data, ...res.data }
          this.isDataLoading = false
        },
        this.emitOpenModal('seeEdge'),
      )
    },
    exportEdges () {
      DIRECTOR.exportEdges()
    },
    addEdge() {
      this.emitOpenModal('add-edit-edge')
    },
    addPublicIp(data) {
      this.emitOpenModal('add-public-ip', data)

    },
  }
}
</script>
